import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';
import clsx from 'clsx';

export default function VideoPlayerCard({ src, className }) {
  return (
    <div 
      className={clsx(className, "w-full h-full flex items-center justify-center overflow-hidden relative bg-black")} 
      onClick={(e) => { e.stopPropagation(); }}
    >
      <MediaPlayer
        src={src}
        viewType="video"
        streamType="on-demand"
        muted
        playsInline
        className="w-full h-full absolute inset-0 flex items-center justify-center"
      >
        <MediaProvider className="w-full h-full object-cover absolute inset-0 m-auto" />
        <DefaultVideoLayout icons={defaultLayoutIcons} />
      </MediaPlayer>
    </div>
  );
}